import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { variables } from "../utility/variables";

import { msalConfig, loginRequest } from '../utility/authConfig';
import { useMsal } from '@azure/msal-react';
import * as Msal from '@azure/msal-browser';

import { useUser } from "../contexts/UserContext";


const SignIn = () => {
  const { instance } = useMsal();
  const { setUser, user } = useUser();
  const { setActiveRoles } = useUser();
  const navigate = useNavigate();

  const handleLogin = async () => {
  
    // Clear session storage
    sessionStorage.clear();
    // Clear local storage
    localStorage.clear();

    // check if there is msal active account
    const account = await instance.getActiveAccount();
    console.log("msal active account ", account);

    // set msal active account if there is no msal active account
    if( !account){
      const loginResponse = await instance.loginPopup(loginRequest);
      instance.setActiveAccount(loginResponse.account);
    }

    try {
      const msalActiveAccount = await instance.getActiveAccount();
      console.log('msalActiveAccount', msalActiveAccount);
      
      if (msalActiveAccount) {
        const userEmail = msalActiveAccount.username;
        console.log(' msalActiveAccount: user\'s email', userEmail);

        // get token, and use it for authentication
        const tokenResponse = await instance.acquireTokenSilent({
          scopes: [`api://${process.env.REACT_APP_ROSTER_CLIENTID}/access_as_user`],
            account: msalActiveAccount,
        });
        const accessToken = tokenResponse.accessToken; 
        const loginResponse = await fetch(variables.API_URL + `User/login`, {
          method: "POST",
          mode: "cors",
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
          credentials: "include", // important to send/set cookies
        });
        if(loginResponse.ok)
        {
          console.log("sign in loginResponse.ok ");
          sessionStorage.setItem("isLoggedIn", true);
          navigate('/agreements');
        }
        else if (loginResponse.status === 400) {
          // 400 Bad Request
          const errorData = await loginResponse.json();
          const errorMessage = errorData.message;
          console.error('Login failed:', errorMessage);
          alert('Login failed: ' + errorMessage);
          sessionStorage.setItem("isLoggedIn", false);
          window.location.reload();
        } else {
          // Other errors
          sessionStorage.setItem("isLoggedIn", false);
          console.error('Unexpected error:', loginResponse.status);
        }
      }
    } catch (error) {
      if (error.name === 'PopupWindowError') {
        console.error("Popup was blocked.");
        alert(
          "The login popup was blocked by your browser. Please enable popups and try again."
        );
      } else if (error.name === 'BrowserAuthError') {
        console.error('The login popup was closed before authentication complete.')
      } else {
        console.error("An error occurred during login:", error);
      }
    }
    
  };

  return (
    <div className="container flex justify-center drop-shadow-md m-5">
      <div className="w-96 rounded-lg border p-6">
        <div className="flex flex-col gap-y-4">
          <h2>Sign In</h2>
          <div className="flex flex-col w-full gap-5">
            <a className="p-3 w-full rounded-lg text-white text-center bg-cyan-800 cursor-pointer" onClick={handleLogin}>Sign In</a>
            <a className="p-3 w-full rounded-lg text-cyan-800 text-center bg-slate-50 cursor-pointer hidden">Request Access</a>
          </div>
        </div>
      </div>
    </div>
  )
}

export default SignIn;
